import { Form } from "../Model/Form";
import { v4 as uuidv4 } from 'uuid';
export class FormsFactory {
    constructor(sectionsFactory) {
        this.sectionsFactory = sectionsFactory;
    }
    createNewForm() {
        return new Form(uuidv4(), // id
        '', // name
        '', // description
        false, // disabled
        true, // status   
        false, // partner
        false, // production
        new Date, // date_created
        new Date, // date_updated
        null, // date_disabled
        []);
    }
    createFormFromState(state) {
        const form = new Form(state.id, state.name, state.description, state.disabled, state.status, state.bodyPartner, state.production, state.date_created, state.date_updated, state.date_disabled, []);
        const sections = state.sections.map(sectionState => this.sectionsFactory.createSectionFromState(form, sectionState));
        for (const section of sections) {
            form.addSection(section);
        }
        return form;
    }
}
